import React, { useMemo, useState } from 'react';
import { Check, ImageIcon } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { BLOG_IMAGE_GALLERY, BLOG_IMAGE_CATEGORIES } from '../config/blogImages';

const baseUrl = (u) => (u || '').split('?')[0];

export const BlogImagePicker = ({ usedImages = [], currentImage, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [cat, setCat] = useState('Mind');

  const usedSet = useMemo(() => new Set(usedImages.map(baseUrl)), [usedImages]);
  const currentBase = baseUrl(currentImage);
  const items = BLOG_IMAGE_GALLERY.filter((i) => cat === 'Mind' || i.category === cat);

  const pick = (url) => { onSelect(url); setOpen(false); };

  return (
    <>
      <Button data-testid="blog-image-gallery-btn" type="button" variant="outline" size="sm" onClick={() => setOpen(true)}
        className="border-gray-700 text-gray-300 hover:bg-gray-800 shrink-0">
        <ImageIcon size={14} className="mr-1.5" /> Galéria
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="blog-image-gallery-dialog" className="bg-gray-900 border-gray-700 text-white max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Fejléckép galéria</DialogTitle>
            <DialogDescription className="text-gray-400">
              Kattints egy képre a kiválasztáshoz. A „Használatban" jelzésű képek már szerepelnek egy másik cikknél — így elkerülöd az ismétlődést.
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-wrap gap-2 mb-3">
            {BLOG_IMAGE_CATEGORIES.map((c) => (
              <button key={c} type="button" data-testid={`gallery-cat-${c}`} onClick={() => setCat(c)}
                className={`px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${
                  cat === c ? 'bg-yellow-600 text-gray-900' : 'bg-gray-800 text-gray-400 hover:bg-gray-700'}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {items.map((img) => {
              const used = usedSet.has(baseUrl(img.url));
              const selected = currentBase === baseUrl(img.url);
              return (
                <button key={img.url} type="button" data-testid={`gallery-img-${baseUrl(img.url).slice(-20)}`}
                  onClick={() => pick(img.url)}
                  className={`relative group rounded-lg overflow-hidden border-2 transition-all aspect-[16/10] ${
                    selected ? 'border-yellow-500' : 'border-transparent hover:border-gray-500'}`}>
                  <img src={img.url.replace('w=1200&h=750', 'w=400&h=250')} alt={img.category} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                  {used && (
                    <span className="absolute top-1.5 left-1.5 text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded bg-gray-950/85 text-amber-300">
                      Használatban
                    </span>
                  )}
                  {selected && (
                    <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-yellow-500 text-gray-900 flex items-center justify-center">
                      <Check size={12} />
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
